export const apiKeysQueryKeys = {
  getAllForCompany: (query: { teamId: string }) =>
    ['apikeys/all-for-company', query] as const
}
